import React from 'react';
import moment from 'moment';

class ParticipantDetails extends React.Component {

  state = {
    id: null
  }

  componentWillReceiveProps = (nextProps) => {
    this.setState({
      id: nextProps.participant.Id,
      gender: nextProps.participant.Gender === "M" ? "Male" : "Female",
      age: nextProps.participant.Age,
      yearsEducation: nextProps.participant.YearsOfEducation,
      diagnosis: nextProps.participant.Diagnosis,
      diseaseSubtype: nextProps.participant.DiseaseSubtype,
      yearsDiagnosis: nextProps.participant.YearsSinceDiagnosis,
      centreNo: nextProps.participant.CentreNumber !== null && nextProps.participant.CentreNumber !== '' ?
        nextProps.participant.CentreNumber : 'N/A' ,
      lastExamDate: nextProps.participant.LastExamDate,
      infoCorrectAsOf: nextProps.participant.InfoCorrectAsOf
    });
  }

  render(){
    return (
      <div>
        <div className="row">
          <div className="col-md-12">
            <h2 className="bicamsColor">BICAMS Participant {this.state.id}</h2>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <h3 className="bicamsColor">Information correct as of {
                      this.state.lastExamDate != null ?
                      moment(this.state.lastExamDate).format('DD-MMM-YYYY')
                      : this.state.infoCorrectAsOf != null ?
                      moment(this.state.infoCorrectAsOf).format('DD-MMM-YYYY')
                      :'N/A'
                      }</h3>
            <p><strong>Gender: </strong> {this.state.gender}</p>
            <p><strong>Age: </strong> {this.state.age}</p>
            <p><strong>Years of Education: </strong> {this.state.yearsEducation}</p>
            <p><strong>Diagnosis: </strong> {this.state.diagnosis}</p>
            <p><strong>Disease Sub-type: </strong> {this.state.diseaseSubtype}</p>
            <p><strong>Years Since Diagnosis: </strong> {this.state.yearsDiagnosis}</p>
            <p><strong>Centre number: </strong> {this.state.centreNo}</p>
          </div>
        </div>
      </div>
    );
  }

}

export default ParticipantDetails;


// WEBPACK FOOTER //
// ./src/components/participants/ParticipantDetails.js